export class Conciliacion {
   emisorId: string;
   dateString: string;
   usuarioId: string;
   sucursalId: string;
   mensual: boolean;
}

export interface ImportacionBoletasSiiTotales {
   totalBoletasReporte: number;
   totalBoletasPeriodo: number;
   totalBoletasExistentes: number;
   totalBoletasNuevas: number;
}

export interface ImportacionBoletasSiiStatus {
   puedeImportar: boolean;
   estado?: string;
   ambiente: string;
   fechaInicio?: string;
   fechaUltimaImportacion?: string;
   origen?: string;
   modalidad?: string;
   totalBoletasReporte?: number;
   totalBoletasPeriodo?: number;
   totalBoletasExistentes?: number;
   totalBoletasNuevas?: number;
   mensaje: string;
}
